import { toast } from "react-toastify";
import { timeToast } from "../../../Constant";
import { APISentFailedMsg } from "../../../Constant/Message";

toast.configure();

const createAnggaranDipakaiTransaksi = async (axiosInstance, formData) => {
  return await axiosInstance
    .post("anggaran-dipakai-transaksi/", formData)
    .catch((error) => {
      console.log(APISentFailedMsg);
      toast.error(`POST Anggaran Dipakai Transaksi ${error.message}`, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: timeToast,
      });
    });
};

export default createAnggaranDipakaiTransaksi;
